import "./homeBlog.css";
import TestImage from "./homepage_images/busienss.jpg";

import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import StopRoundedIcon from "@mui/icons-material/StopRounded";

const blogs = [
  {
    title:
      "Expert Insights and Wellness Resources to Help You Become the Best Version.",
    description:
      "Whether you're overcoming challenges, seeking personal growth, or exploring.",
    author: "Rhonda Rhodes",
    date: "Jun 4, 2026",
    featured: false,
  },
  {
    title:
      "A Resource Center for Healing, Mindfulness, & Positive Transformation",
    description:
      "Learn how hypnotherapy and the mindful practices can support your emotional.",
    author: "Kenneth Allen",
    date: "Jun 13, 2026",
    featured: true,
  },
  {
    title:
      "Guidance, Inspiration, Practical Tools for a Happier and More Balanced Life",
    description:
      "From reducing stress & overcoming fears to building confidence and embracing.",
    author: "Autumn Phillips",
    date: "Jun 14, 2026",
    featured: false,
  },
];

const HomeBlog = () => {
  return (
    <section className="homeBlog ">
      <div className="homeBlogHeading fx-cl fx-ac space2">
        <div className="fx-ac space">
          <span className="homeBlogDot"></span>
          <span className="fs4 fw600">Our Blog</span>
        </div>

        <h2 className="fs9 lh1 fw400">
          Insights, Inspiration, And Guidance For
          <br />
          Your Journey To Positive Change
        </h2>
      </div>

      <div className="homeBlogGrid g g3 space2">
        {blogs.map((item, index) => (
          <article className="homeBlogCard fx-cl" key={index}>
            <img src={TestImage} alt="" className="homeBlogImage" />

            <div className="homeBlogBody fx-cl space2">
              <span className="homeBlogTag">Hypnotherapy</span>

              <h3>{item.title}</h3>

              <p>{item.description}</p>

              <button
                className={`homeBlogBtn ${item.featured ? "active" : ""}`}
              >
                <StopRoundedIcon sx={{ fontSize: "1.2rem" }} />
                READ MORE
              </button>
            </div>

            <div className="homeBlogFooter fx fx-ac fx-jb">
              <div className="fx-ac space">
                <PersonOutlineOutlinedIcon sx={{ fontSize: "1.8rem" }} />
                <span>{item.author}</span>
              </div>

              <div className="fx-ac space">
                <CalendarTodayOutlinedIcon sx={{ fontSize: "1.6rem" }} />
                <span>{item.date}</span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default HomeBlog;
